import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type GetSendAsAddressesResponse = {
  addresses: string[];
};

export async function getSendAsAddresses(): Promise<
  Result<GetSendAsAddressesResponse, ApiError>
> {
  try {
    const { data } = await axios.get<GetSendAsAddressesResponse>(
      '/user/send-as-addresses'
    );
    return ok(data);
  } catch (error) {
    captureException(error, { functionName: 'getSendAsAddresses' });

    if (!isAxiosError(error)) {
      return err({ message: `${error}` });
    }

    return err({
      message: error?.response?.data,
    });
  }
}
